import { useMutation } from '@apollo/client/react';
import { useCallback, useEffect, useState } from 'react';

import {
  GetPatientProfileMedixsPatientDocument,
  GetReceptionPaneAppointmentDocument,
  ReceptionPanePatientFragment,
  UnidentifyMedixsPatientDocument,
} from '~/graphql/generated/graphql';

type Props = {
  patient: ReceptionPanePatientFragment | undefined | null;
  appointmentId: string;
};

export const useUnlinkMedixsPatient = ({ patient, appointmentId }: Props) => {
  const [error, setError] = useState<Error | null>(null);
  const [unidentifyMedixsPatient, { loading, error: unlinkError }] = useMutation(
    UnidentifyMedixsPatientDocument,
    {
      refetchQueries: [
        { query: GetReceptionPaneAppointmentDocument, variables: { appointmentId } },
        { query: GetPatientProfileMedixsPatientDocument, variables: { patientId: patient?.id } },
      ],
    },
  );
  const handleUnlink = useCallback(() => {
    if (patient?.medixsPatient && appointmentId) {
      unidentifyMedixsPatient({
        variables: {
          input: {
            medixsPatientId: patient.medixsPatient?.id,
          },
        },
      });
    }
  }, [unidentifyMedixsPatient, patient?.medixsPatient, appointmentId]);

  useEffect(() => {
    if (unlinkError) {
      setError(unlinkError);
    }
  }, [unlinkError]);

  return { handleUnlink, loading, error };
};
